import __ from './__';

export default (maxLength: number) => (value: string) => {
  if ((value || '').length > maxLength) {
    return `${__('Maximálny počet znakov je')} ${maxLength}`;
  }
  return null;
};
